<template>
  <div class="lodege-user">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
      <el-form-item label="姓名">
        <el-input v-model="dataForm.realName"></el-input>
      </el-form-item>
      <el-form-item label="时间" v-if="type">
        <el-date-picker
          v-model="dataForm.createTime"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
        <el-button @click="cleaList()">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;">
      <el-table-column prop="createUser" align="center" min-width="150" label="投诉人"></el-table-column>
      <el-table-column prop="jobNumber" align="center" min-width="150" label="工号"></el-table-column>
      <el-table-column prop="roleName" align="center" min-width="180" label="岗位"></el-table-column>
      <el-table-column prop="professionName" align="center" min-width="180" label="工种"></el-table-column>
      <el-table-column prop="teamName" align="center" min-width="180" label="所属团队"></el-table-column>
      <el-table-column prop="createTime" align="center" min-width="180" label="投诉时间"></el-table-column>
      <el-table-column align="center" min-width="150" label="投诉内容">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.complaintId)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <lodge-edit v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></lodge-edit>
  </div>
</template>

<script>
import lodgeEdit from "./comm/lodgeEdit";
import { lodgeList, lodgeSave } from './api';
export default {
  components: {
    lodgeEdit,
  },
  data() {
    return {
      dataForm: {
        realName: "",
        createTime: ""
      },
      dataList: [{}],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      type: ''
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    // 获取投诉列表
    getDataList(page) {
      this.dataListLoading = true;
      // 判断组长和公司管理
      if(sessionStorage.getItem('isChairman')  == 'Y'){
        this.type = true;
      }else if(sessionStorage.getItem('isLeader')  == 'Y') {
        this.type = false;
      };
      lodgeList({
          page: page || this.pageIndex,
          limit: this.pageSize,
          realName: this.dataForm.realName || null,
          createTime: this.dataForm.createTime || null
      }).then( data => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 删除
    deleteHandle(id) {
      var userIds = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.userId;
          });
      this.$confirm(
        `确定对[id=${userIds.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          lodgeDelete([userIds]).then( data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.addBtn {
  margin-bottom: 20px;
}
</style>